<template>
    <ul class="ds-main-menu">
        <li class="ds-main-menu-item" v-if="canViewSchedule"><router-link class="ds-main-menu-link" to="/">{{ $t('menu.schedule') }}</router-link></li>
        <li class="ds-main-menu-item" v-if="canViewUserList"><router-link class="ds-main-menu-link" to="/employees">{{ $t('menu.employees') }}</router-link></li>
        <li class="ds-main-menu-item" v-if="canViewExchange"><router-link class="ds-main-menu-link" to="/exchange">{{ $t('menu.exchange') }}</router-link></li>
        <li class="ds-main-menu-item" v-if="canViewAnalytics"><router-link class="ds-main-menu-link" to="/analytics">{{ $t('menu.analytics') }}</router-link></li>
        <li class="ds-main-menu-item" v-if="isAdmin"><router-link class="ds-main-menu-link" to="/settings">{{ $t('menu.settings') }}</router-link></li>
    </ul>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useAuthStore } from '@/stores/authStore';

const store = useAuthStore()
const isAdmin = computed(() => store.permissions?.can_edit_roles)
const canViewSchedule = computed(() => store.permissions?.can_view_schedule_and_timesheet)
const canViewUserList = computed(() => store.permissions?.can_view_user_list)
const canViewExchange = computed(() => store.permissions?.can_view_shift_exchange)
const canViewAnalytics = computed(() => store.permissions?.can_manage_analytics)
</script>